import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { IZS_API_KEY } from '../../_constants/izs-api-key.const';

interface IzsWidgetType {
  init: (selector: string, options: { apiKey: string; pdlId: string }) => void;
}

@Component({
  selector: 'base-customer-izs-widget',
  templateUrl: './izs-widget.component.html',
})
export class BaseCustomerIZSWidgetComponent implements AfterViewInit {
  @Input({ required: true }) pdlId: string;
  @ViewChild('iframeElement', { static: true }) iframeElement!: ElementRef;
  apiKey = IZS_API_KEY;

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit() {
    const iframe = this.iframeElement.nativeElement as HTMLIFrameElement;
    iframe.srcdoc = '<html><head></head><body></body></html>';

    iframe.addEventListener('load', () => {
      const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
      if (iframeDocument) {
        this.injectElement(iframeDocument, 'script', {
          src: 'https://widget-izs.s3.eu-north-1.amazonaws.com/izs-widget.js',
          onload: () => this.initWidget(iframeDocument),
        });

        this.injectElement(iframeDocument, 'link', {
          rel: 'stylesheet',
          href: 'https://widget-izs.s3.eu-north-1.amazonaws.com/izs-style.css',
        });
      }
    });
  }

  private initWidget(iframeDocument: Document) {
    // Create a container inside iframe body
    const div = this.renderer.createElement('div');
    div.id = 'izsWidget';
    this.renderer.appendChild(iframeDocument.body, div);

    const izsWidget = (iframeDocument.defaultView as { IzsWidget?: IzsWidgetType })?.IzsWidget;

    if (izsWidget) {
      izsWidget.init('#izsWidget', {
        apiKey: this.apiKey,
        pdlId: this.pdlId,
      });
    }
  }

  private injectElement(document: Document, tagName: string, attributes: { [key: string]: string | (() => void) }) {
    const element = this.renderer.createElement(tagName);
    for (const [key, value] of Object.entries(attributes)) {
      if (typeof value === 'function') {
        element[key] = value;
      } else {
        this.renderer.setAttribute(element, key, value);
      }
    }
    this.renderer.appendChild(document.head, element);
  }
}
